(function () {
    'use strict';
    var controllerId = 'aziendaAdd';
    angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'common', 'azienda', aziendaAddFn]);

    function aziendaAddFn($scope, $uibModalInstance, datacontext, common, azienda) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        $scope.azienda = azienda;
        $scope.titolo = 'Nuovo azienda';

        //datapicker
        $scope.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.opened = !$scope.opened;
        };

        $scope.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        $scope.format = 'dd/MM/yyyy';

        $scope.ok = function (isValid) {
            if (isValid) {
                var result = {};
                addItem($scope.azienda).then(function (result) {
                    if (result.Id && result.Id > 0)
                        $uibModalInstance.close(result);
                });
            }
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        // Aggiunta elemento
        function addItem(item) {
            return datacontext.azienda_add(item).then(function (data) {                
                if (!data || data.Id == null || data.Id == 0) {
                    logError("Errore durante la creazione del dato");           
                    return null;
                }

                return data;                                                    
            });
        }
    }
})();